export const degree = [
  {
    id: "1",
    name: "학사",
  },
  {
    id: "2",
    name: "석사과정",
  },
  {
    id: "3",
    name: "석사 수료",
  },
  {
    id: "4",
    name: "석사",
  },
  {
    id: "5",
    name: "박사과정",
  },
  {
    id: "6",
    name: "박사수료",
  },
  {
    id: "7",
    name: "박사",
  },
];
